import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Container, Row, Col, Button } from "reactstrap";
import Filter from "./Filter";
import Table from "./Table";
import style from "./Options.module.scss";
import CircularProgress from "../../../../../CircularProgress/CircularProgress";
import { getOptionFieldsFromTicker } from "../../../../../../utils/Order/Order";

class Options extends Component {
  constructor(props) {
    super(props);
    this.state = defaultState;
  }

  componentDidMount() {
    this.props.setValues(() => {
      this.setState(defaultState, () => this.fetchOptions());
    });
  }

  fetchOptions() {
    const { symbol } = this.props;

    this.props.fetchOptions({ date: this.state.selected, symbol }).then((response) => {
      const yahooData = JSON.parse(response.response);
      const optionChain = yahooData.optionChain;

      if (optionChain.result.length != 0 && optionChain.result[0].expirationDates.length != 0) {
        let rows = {};

        const calls = optionChain.result[0].options[0].calls;
        const puts = optionChain.result[0].options[0].puts;
        const strikes = optionChain.result[0].strikes;
        const range = optionChain.result[0].expirationDates.map((e) => {
          return { id: e, date: new Date(e * 1000) };
        });

        strikes.forEach((strike) => (rows[strike] = { call: {}, put: {} }));
        calls.forEach((call) => Object.assign(rows[call.strike].call, call));
        puts.forEach((put) => Object.assign(rows[put.strike].put, put));

        this.setState({
          rows,
          range,
          loading: false,
          description: optionChain.result[0].quote.longName,
          selected: optionChain.result[0].options[0].expirationDate,
        });
      } else {
        this.setState({ loading: false, rows: {} });
      }
    });
  }

  onChangeDate = (value) => {
    this.setState({ selected: value, loading: true }, () => this.fetchOptions());
  };

  useOption = (option) => {
    const optionFields = getOptionFieldsFromTicker(option.contractSymbol);
    this.props.onChange(optionFields);
    this.props.toggle();
  };

  render() {
    const { open, toggle } = this.props;
    const { range, selected, rows, description, loading } = this.state;

    return (
      <div>
        <Modal isOpen={open} toggle={toggle} className={style.modal}>
          <ModalHeader toggle={toggle}>Options List</ModalHeader>
          <ModalBody className={style.body}>
            <Container>
              <Row>
                <Col lg={12}>
                  {range.length > 0 && (
                    <Filter
                      onChange={this.onChangeDate}
                      description={description}
                      selected={selected}
                      range={range}
                    />
                  )}
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  {loading ? <CircularProgress /> : <Table rows={rows} useOption={this.useOption} />}
                </Col>
              </Row>
            </Container>
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={toggle}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const defaultState = {
  range: [],
  selected: null,
  rows: {},
  description: null,
  loading: true,
};

export default Options;
